<template lang="pug">
div
  template(v-if="currentMlTab == 'memberlinkage'")
    .card.mb-0
      .card-header
        .row.w-100
          .form-group.col-12.col-xl-3.mb-1
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.linkage') }}
              LinkageOperatorLookup(
                v-if="displayTable"
                size="sm"
                type="array"
                v-model="linkageType"
                :disabled="loading"
                :operatorID="operatorID"
                @input="getStatement(true)"
              )
          .form-group.col-12.col-xl-3.mb-1(v-if="!isOperator")
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.full_linkage') }}
              b-form-select(v-model="fullLinkage" @change="getStatement(true)" size="sm")
                option(:value="true") {{ $t('ui.all') }}
                option(:value="false") {{ $t('ui.operator') }}
          .form-group.col-12.mb-1
            SubmitButton(
              icon="fa fa-search"
              :loading="loading"
              :text="$t('ui.search')"
              type="button"
              @click="getStatement(true)"
              variant="primary"
              size="sm"
            ).mr-2
            jsonToExcel(v-if="statementList.length > 0" mode="MemberLinkage" tbl="mlList" :date="dateRange")
            memberLinkageExport(v-if="statementList.length > 0" :tbl="statementList" tblId="mlList" :isOperator="isOperator")
      .card-body
        .row
          .col-10.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRow"
              :per-page="getPageSize"
              v-model="currentPage"
              @input="changedPage($event)")
          .col-2.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
          .col-12(style="max-height: 70vh; overflow: hidden;")
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover#dsList
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th(width="10%" @click="sortOrder('parent_id')" v-if="!isOperator")
                      span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                      .float-right
                        i(:class="changeSortKey('parent_id')")
                    th(width="10%" @click="sortOrder('member_id')")
                      span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                      .float-right
                        i(:class="changeSortKey('member_id')")
                    th(width="10%")
                      span(:title="$t('ui.second_id')") {{ $t('ui.second_id') }}
                    th(width="10%")
                      span(:title="$t('ui.linkage')") {{ $t('ui.linkage') }}
                    th.text-right(width="10%" @click="sortOrder('total_risk_score')")
                      span(:title="$t('ui.total_risk_score')") {{ $t('ui.total_risk_score') }}
                      .float-right
                        i(:class="changeSortKey('total_risk_score')")
                tbody.clusterize-content
                  tr(v-if="statementList.length == 0")
                    td(colspan="6").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in statementList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td(v-if="!isOperator")
                      span(:title="item.parent_id") {{ item.parent_id }}
                    td
                      span(:title="item.member_id") {{ item.member_id }}
                    td
                      b-link.font-weight-bold(href="javascript:void(0);" @click="redirectToMemberLinkageDetail(item)" :title="item.second_id") {{ item.second_id }}
                    td
                      span(:title="item.linkage") {{ item.linkage }}
                    td.text-right
                      span(:title="item.total_risk_score") {{ item.total_risk_score }}


  template(v-else-if="currentMlTab == 'memberLinkageDetail'")
    memberLinkageDetail(ref="memberLinkageDetail" :linkageDetail="linkageDetail" :operatorID="operatorID" :secondMemberName="secondMemberName" @backClick="backClick")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcel.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import memberLinkageDetail from "@/components/reportTab/memberLinkageDetail.vue";
import LinkageOperatorLookup from "@/library/LinkageOperatorLookup";
import memberLinkageExport from "@/components/report/memberLinkageExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    jsonToExcel,
    memberLinkageDetail,
    LinkageOperatorLookup,
    memberLinkageExport
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    },
    memberSecondID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: null,
    sortType: null,
    currentMlTab: 'memberlinkage',
    linkageType: null,
    fullLinkage: false,
    displayTable: false,
    linkageDetail: {
      source_id: null,
      target_id: null,
      linkage_type: null
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    secondMemberName: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
  },
  destroyed: function() {
    var json = {
      linkage_type: null,
      full_linkage: null,
      linkage_type: null
    };

    this.$store.dispatch("user/setMemberLinkageParam", json);
  },
  methods: {
    backClick() {
      this.currentMlTab = 'memberlinkage'
      this.linkageDetail = {
        source_id: null,
        target_id: null,
        linkage_type: null
      }

    },
    refresh() {
      this.displayTable = false;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

      if (this.$store.getters.memberLinkage.linkage_type) {
        this.linkageType = this.$store.getters.memberLinkage.linkage_type;
      }

      if (this.$store.getters.memberLinkage.full_linkage) {
        this.fullLinkage = this.$store.getters.memberLinkage.full_linkage;
      }

      this.getStatement(true);

      setTimeout(() => {
        this.displayTable = true;
      }, 10);
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    setMemberLinkageParam() {
      var json = {
        linkage_type: this.linkageType,
        full_linkage: this.fullLinkage
      };

      this.$store.dispatch("user/setMemberLinkageParam", json);
    },
    redirectToMemberLinkageDetail: function(item) {
      this.linkageDetail = {
        source_id: this.memberSecondID,
        target_id: item.second_id,
        linkage_type: this.linkageType
      }

      this.secondMemberName = item.member_id
      this.currentMlTab = 'memberLinkageDetail'
    },
    getStatement: function(isSearch) {
      this.setMemberLinkageParam();

      let url = config.memberLinkageUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID.trim(),
        member_id: this.memberID.trim(),
        linkage_type: this.linkageType,
        full_linkage: this.fullLinkage,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                  this.statementList = response.data.dt;
                  this.totalRow = response.data.dt.length > 0 ? this.statementList[0]["totalrows"] : 0
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'memberlinkage') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>